<template>
  <!--有子节点-->
  <li class="collapse-submenu" :class="{'has-icon': menuData.hasIcon, 'open': expand}" v-if="menuData.children">
    <div class="submenu-title"
         v-ripple
         :style="{'padding-left': getPaddingLeft + 'px'}"
          @click="submenuClick">
            <span class="menu-icon" v-if="menuData.hasIcon">
              <slot name="icon" :item="menuData">
                <svg class="iconfont-symbol">
                  <use :xlink:href="menuData.iconName"></use>
                </svg>
              </slot>
            </span>
      <div class="menu-text">
        <slot :menuData="menuData">{{menuData.text}}</slot>
      </div>
      <span class="arrow-border" :class="{'arrow-border-right': !expand, 'arrow-border-bottom': expand}"></span>
    </div>
    <transition
      @beforeEnter="_beforeEnter"
      @enter="_enter"
      @beforeLeave="_beforeLeave"
      @leave="_leave">
      <ul class="collapse-submenu-list" v-if="expand">
        <CollapseMenuItem
          v-for="(child, index2) in menuData.children"
          :menu-data="child"
          :key="uuid()"
          :_parentId="id"
          :padding-left="paddingLeft"
          :icon-distance="iconDistance"
          :exact="exact"
          :onclick="onclick"
          :onopen="onopen"
          :onhide="onhide"></CollapseMenuItem>
      </ul>
    </transition>
  </li>
  <!--无子节点-->
  <li class="collapse-menu-item" :class="{'has-icon': menuData.hasIcon}" v-else-if="!menuData.children">
    <router-link class="menu-link"
                 :to="menuData.url"
                 :style="{'padding-left': getPaddingLeft + 'px'}"
                 :class="{active: isActive}"
                 @click.native="nodeClick"
                 v-ripple
                 v-if="(typeof menuData.isRoute === 'undefined' || menuData.isRoute) && menuData.url">
           <span class="menu-icon" v-if="menuData.hasIcon">
             <slot name="icon" :menuData="menuData">
               <svg class="iconfont-symbol">
                  <use :xlink:href="menuData.iconName"></use>
                </svg>
             </slot>
          </span>
      <div class="menu-text"><slot :menuData="menuData">{{menuData.text}}</slot></div>
    </router-link>
    <a class="menu-link"
       :href="!menuData.url ? 'javascript: (void);' : menuData.url"
       :style="{'padding-left': getPaddingLeft + 'px'}"
       :class="{active: isActive}"
       @click="nodeClick"
       v-ripple
       v-else>
              <span class="menu-icon" v-if="menuData.hasIcon">
                 <slot name="icon" :menuData="menuData">
                   <svg class="iconfont-symbol">
                      <use :xlink:href="menuData.iconName"></use>
                   </svg>
                 </slot>
              </span>
      <div class="menu-text"><slot :menuData="menuData">{{menuData.text}}</slot></div>
    </a>
  </li>
</template>

<script>
import { addClass, removeClass, on, off } from '../untils';

export default {
  name: 'CollapseMenuItem',
  inject: ['collapseMenu'],
  props: {
    // 菜单节点数据
    menuData: {
      type: Object,
      default () {
        return {};
      },
    },
    // 当前菜单的padding-left
    paddingLeft: {
      type: Number,
      default: 15,
    },
    // 左侧icon与文字之间的距离
    iconDistance: {
      type: Number,
      default: 15,
    },
    // 路由全包含匹配
    exact: {
      type: Boolean,
      default: false,
    },
    // 父节点id
    _parentId: {
      type: String,
      default: '',
    },
    // 节点点击事件
    onclick: {
      type: Function,
      default: undefined,
    },
    // 节点展开事件
    onopen: {
      type: Function,
      default: undefined,
    },
    // 节点收缩事件事件
    onhide: {
      type: Function,
      default: undefined,
    },
  },
  data () {
    return {
      expand: this.menuData.open || false,
      id: 'collapseMenuItem_' + this.collapseMenu.count++,
      // id: 'collapseMenuItem_' + new Date().getTime() + Math.random().toString(32).substr(2)
    };
  },
  methods: {
    setOpen (flag) {
      flag = !!flag;
      this.expand = flag;
    },
    // 子节点点击事件
    submenuClick () {
      this.expand = !this.expand;
      if (this.expand) {
        this.onopen && typeof this.onopen === 'function' && this.onopen(this);
      } else {
        this.onhide && typeof this.onhide === 'function' && this.onhide(this);
      }
    },
    // 节点点击事件
    nodeClick () {
      this.onclick && typeof this.onclick === 'function' && this.onclick(this);
    },
    // 判断路由与指定菜单项的url是否匹配
    selected (item) {
      let exact = item.exact;
      if (typeof exact === 'undefined') {
        exact = this.exact;
      }
      if (exact) {
        // 如果设置exact为true，则是路径全包含匹配
        return item.url === this.$route.fullPath;
      } else {
        // 如果exact为false，并且没有设置baseUrl，则将url与路由中的path进行比对
        if (!item.baseUrl) {
          return item.url === this.$route.path;
        } else {
          // 如果exact为true，并且设置了baseUrl，则只要路由中包含baseUrl即可
          return new RegExp(item.baseUrl).test(this.$route.path);
        }
      }
    },
    // 获取与路由匹配的子菜单(也有可能子菜单的子菜单)
    getChildWithPath (children) {
      let res;
      if (children && children.length) {
        children.forEach(item => {
          if (this.selected(item)) {
            res = item;
          } else if (item.children && item.children.length) {
            res = this.getChildWithPath(item.children);
          };
        });
      }
      return res;
    },
    // 父节点展开
    parentNodeOpen (vm) {
      if (vm._parentId) {
        let $parent = vm.$parent;
        if (!$parent.expand) {
          $parent.setOpen(true);
        }
        if ($parent._parentId) {
          this.parentNodeOpen($parent.$parent);
        }
        $parent = null;
      }
    },
    uuid () {
      return Math.random().toString(32).substr(2) + '_' + new Date().getTime() + '_' + Math.random().toString(32).substr(2);
    },
    // 计算当前节点层级
    _calculateLevel (vm) {
      let level = 0;
      let componentName = vm.$options.name;
      if (componentName === 'CollapseMenuItem') {
        level++;
        level += this._calculateLevel(vm.$parent);
      } else if (componentName === 'QSlideTransition') {
        level += this._calculateLevel(vm.$parent);
      }
      return level;
    },
    // 获取有icon的父节点个数
    _getQuantityForParentHasIcon (parentVm) {
      let quantity = 0;
      let componentName = parentVm.$options.name;
      if (componentName === 'CollapseMenuItem') {
        if (parentVm.menuData.hasIcon) {
          quantity++;
        }
        quantity += this._getQuantityForParentHasIcon(parentVm.$parent);
      } else if (componentName === 'QSlideTransition') {
        quantity += this._getQuantityForParentHasIcon(parentVm.$parent);
      }
      return quantity;
    },
    _beforeEnter (el) {
      addClass(el, 'transition-am');
      el.style.height = 0;
      el.style.overflow = 'hidden';
    },
    _enter (el, done) {
      const fn = () => {
        done();
        removeClass(el, 'transition-am');
        off(el, 'transitionend', fn);
        el.style.height = '';
        el.style.overflow = '';
      };
      on(el, 'transitionend', fn);
      let timer = setTimeout(() => {
        clearTimeout(timer);
        el.style.height = `${el.scrollHeight}px`;
        el.style.overflow = 'hidden';
      }, 10);
    },
    _beforeLeave (el) {
      addClass(el, 'transition-am');
      el.style.height = `${el.scrollHeight}px`;
      el.style.overflow = 'hidden';
      el.setAttribute('data-state', 'beforeLeave');
    },
    _leave (el, done) {
      const fn = () => {
        done();
        removeClass(el, 'transition-am');
        off(el, 'transitionend', fn);
        el.style.height = '';
        el.style.overflow = '';
        el.style.opacity = '';
      };
      on(el, 'transitionend', fn);
      // 如果不加setTimeout，则元素收缩时不会有动画
      let timer = setTimeout(() => {
        clearTimeout(timer);
        el.style.height = '0';
        el.style.opacity = 0;
      }, 10);
    },
  },
  computed: {
    // 判断父组件是否有icon
    parentHasIcon () {
      let $parent = this.$parent;
      let vmName = $parent.$options.name;
      if (vmName === 'CollapseMenuItem') {
        return $parent.menuData.hasIcon;
      } else {
        return false;
      }
    },
    // 计算padding-left
    getPaddingLeft () {
      let pl = this._calculateLevel(this) * this.paddingLeft;
      let mr = this._getQuantityForParentHasIcon(this.$parent) * this.iconDistance;
      return pl + mr;
    },
    // 当前节点是否选中
    isActive () {
      return this.selected(this.menuData);
    },
  },
  mounted () {
    if (this.collapseMenu.autoOpen) {
      let child = this.getChildWithPath(this.menuData.children);
      if (child) {
        this.expand = true;
      }
    }
  },
};
</script>

<style lang="stylus">

</style>
